import BulkOrderOrdererDetailNewPage from '../../../components/pages/bulk_order/orderer_details/BulkOrderOrdererDetailNewPage.vue'

export default {
  components: { BulkOrderOrdererDetailNewPage }
}
